import React from 'react'

import classNames from 'classnames'
import { ErrorMessage, Field, FieldHookConfig, FieldInputProps, useField } from 'formik'
import Select from 'react-select'

import { Options } from '@/features/application/applicationSlice'

const mapOptions = (values: Options, options: Options) => {
  if (!values || values?.length === 0 || typeof values[0] === 'object') {
    return values
  }

  const mappedOptions = []

  options?.forEach((option) => {
    if (values.includes(option)) {
      mappedOptions.push(option)
    }
  })

  return mappedOptions
}

interface SelectFieldCustomProps {
  options: Options
  field: FieldInputProps<any>
  form: any // @TODO - Find a way to improve this
  onBlur?: React.ReactEventHandler
  width?: string
  disabled?: boolean
  selectClass?: string
  placeholderClass?: string
}

/**
 * @deprecated use Formik > Field and customize at the feature level
 * @see useForm() hook
 */
const SelectField = (props: SelectFieldCustomProps) => {
  props.field.value = mapOptions(props.field.value, props.options)

  return (
    <Select
      {...props.field}
      isMulti
      options={props.options}
      onChange={(option) => {
        props.form.setFieldValue(props.field.name, option)
        props.form.setFieldTouched(props.field.name)
      }}
      onMenuOpen={() => {
        props.form.setFieldTouched(props.field.name)
      }}
      onBlur={props.onBlur || undefined}
      isDisabled={props.disabled}
      className={`mt-1 ${props.width || 'w-full'} border-sky-200`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      classNames={{
        control: () => props.selectClass,
        placeholder: () => props.placeholderClass,
      }}
    />
  )
}

interface MultiSelectFieldCustomProps {
  options: Options
  label?: string
  inlineLabel?: boolean
  selectClass?: string
  placeholderClass?: string
  showError?: boolean
}

type MultiSelectFieldProps = MultiSelectFieldCustomProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSelectElement>, HTMLSelectElement> &
  FieldHookConfig<string>

const MultiSelectField = (props: MultiSelectFieldProps) => {
  const { label, inlineLabel = false, options } = props
  const [field] = useField(props.name)

  const wrapperClasses = classNames({
    'flex items-center': inlineLabel,
  })

  const labelClasses = classNames(
    {
      'mr-2': inlineLabel,
    },
    'text-sm text-gray-400'
  )

  return (
    <div className={wrapperClasses}>
      {label && <label className={labelClasses}>{label}</label>}
      <Field
        {...field}
        {...props}
        options={options}
        component={SelectField}
      />
      {props.showError && (
        <ErrorMessage
          component='span'
          name={field.name}
          className={`mt-1 text-error`}
        />
      )}
    </div>
  )
}

export default MultiSelectField
